/* Sağlık ve Trafik sekmelerinin ortak iki parçası: tek sayılık kutu ve
   sıralı liste. */

import type { Ranked } from '../api.ts';
import { el } from '../dom.ts';

export function kpi(name: string, value: string, sub: string): HTMLElement {
  return el('div', { class: 'tile' }, el('p', { class: 'tile-name', text: name }), el('p', { class: 'tile-value', text: value }), el('p', { class: 'dim', text: sub }));
}

export function ranked(title: string, rows: Ranked[], total: number): HTMLElement {
  return el(
    'section',
    {},
    el('p', { class: 'tile-name', text: title }),
    rows.length === 0
      ? el('p', { class: 'dim', text: 'veri yok' })
      : el(
          'table',
          {},
          el(
            'tbody',
            {},
            ...rows.map((r) =>
              el(
                'tr',
                {},
                el('td', { text: r.key, style: 'overflow-wrap:anywhere' }),
                el('td', { class: 'dim', text: r.count.toLocaleString('tr-TR'), style: 'text-align:right' }),
                el('td', { class: 'dim', text: total > 0 ? `%${Math.round((r.count / total) * 100)}` : '', style: 'text-align:right;width:3.5em' })
              )
            )
          )
        )
  );
}
